import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'admin-pages-new-issue-search-transition.title',
		defaultMessage: 'New issue search',
		description: 'Main heading for the new issue search settings page',
	},
	summary: {
		id: 'admin-pages-new-issue-search-transition.summary',
		defaultMessage:
			"We'll be moving all users to the new issue search. Eventually, we'll remove access to the old issue search. Your users will receive a tour in Jira to transition them to the new issue search.",
		description: 'First section of the summary for the new issue search transition settings page',
	},
	learnMore: {
		id: 'admin-pages-new-issue-search-transition.learn-more',
		defaultMessage: '{linkStart}Learn more about the new issue search.{linkEnd}',
		description: 'Learn more link which open in-product help if available',
	},
	toggleHeaderEnabled: {
		id: 'admin-pages-new-issue-search-transition.toggle-header-enabled',
		defaultMessage: 'Set the default issue search for your users below:',
		description: 'Second section of the summary before the toggle, when the toggle is enabled',
	},
});
